/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CategoryResponseAdminDto } from '../../models/category-response-admin-dto';
import { ReorderCategoriesDto } from '../../models/reorder-categories-dto';

export interface AdminCategoriesControllerReorderCategoriesV1$Params {
      body: ReorderCategoriesDto
}

export function adminCategoriesControllerReorderCategoriesV1(http: HttpClient, rootUrl: string, params: AdminCategoriesControllerReorderCategoriesV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CategoryResponseAdminDto>>> {
  const rb = new RequestBuilder(rootUrl, adminCategoriesControllerReorderCategoriesV1.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CategoryResponseAdminDto>>;
    })
  );
}

adminCategoriesControllerReorderCategoriesV1.PATH = '/v1/admin/categories/reorder';
